export const validateModelSKU = async (rule,value) => {
    if(value && !(/^(?=.*[A-Z])(?=.*\d)[^\s]+$/.test(value))){
        throw new Error('Debe tener caracteres alfanumericos en mayuscula');
    }
}

export const validateColor = async (rule,value) => {
    if(value && !(/^[a-zA-ZÑñáéíóúÁÉÍÓÚ\s.'-]+$/.test(value))){
        throw new Error('Solamente caracteres alfabeticos');
    }
}

export const validateQty = async (rule,value) => {
    if(value && !(/^[0-9]+$/.test(value))){
        throw new Error('Solamente se aceptan numeros enteros');
    }
}

export const validatePrice = async (rule,value) => {
    if(value && !(/^\d+(?:\.\d{1,2})?$/.test(value))){
        throw new Error('Entrar un precio con maximo dos decimales');
    }
}